module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box"
  }, [(_vm.billingCallSessionEnabled) ? _c('div', {
    staticClass: "pull-right text-muted"
  }, [_vm._v("\n    En session d'appel effectuez un suivi en bas de l'écran.\n  ")]) : _c('div', [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Créer un appel téléphonique"
    }
  }, [_c('el-button', {
    directives: [{
      name: "create",
      rawName: "v-create:call",
      value: ({
        customer: _vm.customer,
        reminder: _vm.getLastReminder()
      }),
      expression: "{customer: customer, reminder: getLastReminder()}",
      arg: "call"
    }],
    staticClass: "pull-right",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-plus",
      "circle": ""
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Saisir un commentaire manuel"
    }
  }, [_c('el-button', {
    directives: [{
      name: "create",
      rawName: "v-create:comment",
      value: ({
        customer_id: _vm.customer.id
      }),
      expression: "{customer_id: customer.id}",
      arg: "comment"
    }],
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "success",
      "circle": ""
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-comment"
  })])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Saisir un rappel manuel"
    }
  }, [_c('el-button', {
    directives: [{
      name: "create",
      rawName: "v-create:reminder",
      value: ({
        customer_id: _vm.customer.id
      }),
      expression: "{customer_id: customer.id}",
      arg: "reminder"
    }],
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "success",
      "circle": ""
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-notifications"
  })])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Saisir une signature de propale"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "success",
      "circle": "",
      "disabled": _vm.relations.proposals.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openSignProposal()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-star"
  })])], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Suivi commercial")]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Timeline (' + _vm.customerComments.length + ')',
      "name": "Timeline"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Devis B2B (' + _vm.customerOldComments['Devis B2B'].length + ')',
      "name": "Devis B2B"
    }
  })], 1), _vm._v(" "), (_vm.tab === 'Timeline') ? _c('div', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.hideNonSuccessCall),
      callback: function($$v) {
        _vm.hideNonSuccessCall = $$v
      },
      expression: "hideNonSuccessCall"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Cacher les appels non aboutis")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, _vm._l((_vm.timeline), function(items, key) {
    return _c('article', {
      class: [
        'timeline-item',
        _vm.moment(items.timelineDate).format('YYYY-MM-DD HH:00') === _vm.moment().format('YYYY-MM-DD HH:00') ? 'timeline-item-now' : '',
        _vm.moment(items.timelineDate).isAfter(_vm.moment()) && (key + 1) in _vm.timeline && _vm.moment(_vm.timeline[(key + 1)].timelineDate).isBefore(_vm.moment()) ? 'timeline-item-separation' : ''
      ]
    }, [_c('div', {
      staticClass: "timeline-desk"
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "timeline-box"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), (items[0].user_id) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.getUserTooltip(items[0].user_id, items[0]),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "timeline-icon",
      style: (_vm.getTimelineStyle(items[0]))
    }, [_c('gravatar', {
      staticClass: "img-circle",
      attrs: {
        "email": _vm.getUserEmail(items[0].user_id),
        "alt": "user"
      }
    })], 1)]) : _c('span', {
      staticClass: "timeline-icon"
    }, [_c('span', [_c('i', {
      staticClass: "fas fa-user",
      staticStyle: {
        "font-size": "1.7em",
        "margin": "7px 6px"
      }
    })])]), _vm._v(" "), (_vm.moment(items.timelineDate).format('YYYY-MM-DD HH:00') === _vm.moment().format('YYYY-MM-DD HH:00')) ? _c('h4', {
      staticClass: "m-b-10",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                Maintenant\n              ")]) : (_vm.moment(items.timelineDate).format('YYYY-MM-DD HH:00') === _vm.moment().format('YYYY-MM-DD 00:00')) ? _c('h4', {
      staticClass: "m-b-10"
    }, [_vm._v("\n                Aujourd'hui\n              ")]) : _c('h4', {
      staticClass: "m-b-10"
    }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(items.timelineDate, 'L')) + "\n                "), (_vm.moment(items.timelineDate).format('H') !== '0') ? _c('span', {
      staticClass: "timeline-date text-muted"
    }, [_c('small', [_vm._v(" à " + _vm._s(_vm._f("moment")(items.timelineDate, 'H')) + "h")])]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((items), function(item) {
      return _c('div', {
        key: item.itemType + item.id
      }, [(item.itemType === 'calling') ? _c('div', [_vm._m(0, true)]) : (item.itemType === 'call') ? _c('div', [_c('timeline-call-widget', {
        attrs: {
          "call": item
        }
      })], 1) : (item.itemType === 'reminder') ? _c('div', {
        staticClass: "text-muted"
      }, [_c('span', {
        directives: [{
          name: "edit",
          rawName: "v-edit:reminder",
          value: (item),
          expression: "item",
          arg: "reminder"
        }],
        staticStyle: {
          "cursor": "pointer"
        }
      }, [_c('span', {
        staticClass: "label label-pill label-default",
        style: ({
          background: item.category.color
        })
      }, [_vm._v("\n                        Rappel : " + _vm._s(item.category.name) + "\n                      ")]), _vm._v(" "), (item.meeting) ? _c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": 'Rendez-vous à ' + _vm.moment(item.date.date).format('H:mm'),
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "fa fa-calendar-check-o"
      })]) : _vm._e(), _vm._v(" " + _vm._s(item.description) + "\n                    ")], 1)]) : (item.itemType === 'auto_billing_reminder') ? _c('div', {
        staticClass: "text-muted"
      }, [_c('span', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.updateBillingReminder()
          }
        }
      }, [_c('span', {
        staticClass: "label label-pill label-default",
        style: ({
          background: item.category.color
        })
      }, [_vm._v("\n                        Rappel : Session d'appel facturation\n                      ")]), _vm._v(" "), (item.meeting) ? _c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": 'Rendez-vous à ' + _vm.moment(item.date.date).format('H:mm'),
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "fa fa-calendar-check-o"
      })]) : _vm._e(), _vm._v(" " + _vm._s(item.description) + "\n                    ")], 1)]) : (item.itemType === 'comment') ? _c('div', {
        staticClass: "text-muted",
        staticStyle: {
          "cursor": "pointer"
        }
      }, [_c('span', {
        directives: [{
          name: "edit",
          rawName: "v-edit:comment",
          value: (item),
          expression: "item",
          arg: "comment"
        }]
      }, [_vm._m(1, true), _vm._v(" "), _c('div', {
        staticStyle: {
          "white-space": "pre-wrap",
          "position": "relative",
          "margin-top": "-20px",
          "margin-left": "32px"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getFormattedText(item.description))
        }
      })])]) : (item.itemType === 'proposal') ? _c('div', {
        staticClass: "text-primary"
      }, [_vm._m(2, true), _vm._v(" "), (item.type_id === 1) ? _c('span', [_vm._v("Propale Leads")]) : (item.type_id === 2) ? _c('span', [_vm._v("Propale Rendez-vous")]) : (item.type_id === 3) ? _c('span', [_vm._v("Propale : " + _vm._s(item.amount) + " €")]) : _vm._e()]) : (item.itemType === 'accepted_proposal') ? _c('div', {
        staticClass: "text-primary"
      }, [_vm._m(3, true), _vm._v(" "), (item.type_id === 1) ? _c('span', {
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("Signature Propale Leads")]) : (item.type_id === 2) ? _c('span', {
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("Signature Propale Rendez-vous")]) : (item.type_id === 3) ? _c('span', {
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("Signature Propale : " + _vm._s(item.amount) + " €")]) : _vm._e()]) : _vm._e()])
    }), 0)], 1)]), _vm._v(" "), (_vm.moment(items.timelineDate).isAfter(_vm.moment()) && (key + 1) in _vm.timeline && _vm.moment(_vm.timeline[(key + 1)].timelineDate).isBefore(_vm.moment())) ? _c('div', {
      staticClass: "after-panel-separation"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("A venir")])]) : _vm._e()])])
  }), 0)]) : _c('div', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.customerOldComments[_vm.tab]), function(comment) {
    return _c('div', {
      key: 'c' + comment.id,
      staticClass: "row m-b-10"
    }, [_c('div', {
      staticClass: "col-md-1"
    }, [(comment.badge && comment.badge === 'COMMERCIAL') ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "content": "App. Commerciale",
        "placement": "top"
      }
    }, [_c('div', {
      staticStyle: {
        "background-color": "#64b0f2",
        "padding": "0px",
        "color": "white",
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "zmdi zmdi-phone"
    })])]) : (comment.badge && comment.badge === 'BILLING') ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "content": "App. Facturation",
        "placement": "top"
      }
    }, [_c('div', {
      staticStyle: {
        "background-color": "#FFBC5E",
        "padding": "0px",
        "color": "white",
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "zmdi zmdi-collection-text"
    })])]) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(_vm._f("moment")(comment.created_at, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(comment.user_id) ? _c('span', [_c('user', {
      attrs: {
        "item": _vm.getUser(comment.user_id)
      }
    })], 1) : (_vm.tab !== 'Devis B2B' && comment.user_name) ? _c('span', [_vm._v("\n          " + _vm._s(comment.user_name) + "\n        ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5",
      staticStyle: {
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(comment.description))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(comment.id) ? _c('div', {
      staticClass: "pull-right"
    }, [_c('el-button', {
      directives: [{
        name: "edit",
        rawName: "v-edit:comment",
        value: (comment),
        expression: "comment",
        arg: "comment"
      }],
      attrs: {
        "disabled": comment.user_id !== _vm.user.id,
        "type": "warning",
        "size": "mini",
        "icon": "el-icon-edit",
        "circle": ""
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "delete",
        rawName: "v-delete:comment",
        value: (comment),
        expression: "comment",
        arg: "comment"
      }],
      attrs: {
        "disabled": comment.user_id !== _vm.user.id,
        "type": "danger",
        "size": "mini",
        "icon": "el-icon-close",
        "circle": ""
      }
    })], 1) : _vm._e()])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-sync fa-spin"
  }), _vm._v(" Appel en cours ...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label label-pill label-info"
  }, [_c('i', {
    staticClass: "zmdi zmdi-comment",
    staticStyle: {
      "font-size": "1.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label label-pill label-info"
  }, [_c('i', {
    staticClass: "zmdi zmdi-star",
    staticStyle: {
      "font-size": "1.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label label-pill label-info"
  }, [_c('i', {
    staticClass: "zmdi zmdi-star",
    staticStyle: {
      "font-size": "1.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-1 text-center"
  }, [_c('strong', [_vm._v("App")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('strong', [_vm._v("Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('strong', [_vm._v("Commercial")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-center"
  }, [_c('strong', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d18837f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/Timeline/CustomerTimelineSummaryWidget.vue
// module id = 727
// module chunks = 1